// extracted by mini-css-extract-plugin
export var divider = "References-module--divider--40b73";
export var grid = "References-module--grid--acb6f";
export var title = "References-module--title--c0572";